import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/header';
import api from './api/client';
import fard from './assets/img/fard.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

// Публичная страница /sign-up: заявка на доступ к системе.
// Попадает во вкладку Requests в админке, где её одобряют или отклоняют.
function RequestAccessPage() {
    const [form, setForm] = useState({ firstName: '', lastName: '', login: '', email: '' });
    const [message, setMessage] = useState('');
    const [done, setDone] = useState(false);
    const [sending, setSending] = useState(false);

    const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        setMessage('');
        try {
            const res = await api.post('/api/access-requests', form);
            setMessage(res.data.message);
            setDone(true);
        } catch (error) {
            setMessage(error.response?.data?.error || 'Error submitting request');
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <Header />
            <div className="container">
                <div className="forgot-password">
                    <div className="forgot-password__inner">
                        {done ? (
                            <div className="auth-success">
                                <FontAwesomeIcon icon={faCircleCheck} className="auth-success__icon" />
                                <p className="auth-success__text">{message}</p>
                                <Link to="/login" className="btn btn__green auth-success__btn">Back to Login</Link>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="container__input">
                                    <label className="label">First Name</label>
                                    <input required placeholder="John" value={form.firstName} onChange={set('firstName')} />
                                </div>
                                <div className="container__input">
                                    <label className="label">Last Name</label>
                                    <input placeholder="Doe" value={form.lastName} onChange={set('lastName')} />
                                </div>
                                <div className="container__input">
                                    <label className="label">Desired Login</label>
                                    <input required placeholder="jdoe" value={form.login} onChange={set('login')} />
                                </div>
                                <div className="container__input">
                                    <label className="label">Email (optional, for password recovery)</label>
                                    <input type="email" placeholder="example@mail.com" value={form.email} onChange={set('email')} />
                                </div>
                                <div id="message">{message}</div>
                                <input
                                    type="submit"
                                    className="btn btn__big btn__green align-center mt-12"
                                    disabled={sending}
                                    value={sending ? 'Sending…' : 'Request Access'}
                                />
                                <p className="mt-15 text-center">Already have an account? <Link className="link__green" to="/login">Sign in</Link></p>
                            </form>
                        )}
                    </div>
                    <div className="illustration">
                        <img src={fard} alt="Gardener Illustration" className="illustration_img" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default RequestAccessPage;
